import { render, staticRenderFns } from "./AccountDeleteConfirmation.vue?vue&type=template&id=0c62badd&"
import script from "./AccountDeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./AccountDeleteConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports